/* istanbul ignore file */
import {
  createEventCallbackRedirect,
  EVENT_TIMEOUT_IN_MS,
  sendGAEvent,
} from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { PageType, Product } from 'src/types';
import { isCategoryPage, isPartnerPage, isSearchPage } from 'src/utils';
import { getProductFieldObject } from 'src/utils/googleAnalytics';
import { onProductClick } from '../modules/actions';
import { ClickEcommerce, ProductClick } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [onProductClick.type]: (state, _nextState, action) => {
    const {
      payload: { productCode, productUrl, destinationUrl },
    } = action as ReturnType<typeof onProductClick>;
    const {
      products: { category, items, partner, searchTerm },
      navigation: { pageType },
    } = state;

    const clickedProduct = Object.keys(items)
      .reduce((curr, key) => curr.concat(items[key]), [] as Product[])
      .find((prod) => prod.code === productCode)!;

    const fieldObject = getProductFieldObject(clickedProduct, state);

    const ecommerceClick: ClickEcommerce['click'] = {
      actionField: {
        list: '',
      },
      products: [fieldObject],
    };

    if (isCategoryPage(pageType)) {
      ecommerceClick.actionField.list = `${PageType.Category} - ${category.name}`;
    } else if (isPartnerPage(pageType)) {
      ecommerceClick.actionField.list = `${PageType.Partner} - ${partner!.name}`;
    } else if (isSearchPage(pageType)) {
      ecommerceClick.actionField.list = `${PageType.Search} - ${searchTerm}`;
    }

    if (clickedProduct.isSponsored) {
      ecommerceClick.actionField.list += ' - sponsored';
    }

    sendGAEvent<ProductClick>({
      event: 'product_clicks',
      event_category: 'Product listings',
      event_action: 'Product Click',
      event_label: 'null',
      destination_URL: destinationUrl,
      ecommerce: {
        click: ecommerceClick,
      },
      eventCallback: createEventCallbackRedirect(productUrl),
      eventTimeout: EVENT_TIMEOUT_IN_MS,
    });
  },
};
